export default __webpack_public_path__ + "static/item_13-067722b0b25d11a107fdecb10f48abbd.jpg";